import Vue              from 'vue/dist/vue.min.js';
import Vuex             from 'vuex';
import processors       from './modules/parts.js'
import menuOptions      from './modules/menu.js'
import systemValues     from './modules/system.js'
import compareList      from './modules/compare.js'
import startIndexCPU    from './modules/slider.js'
import adminMenu        from './modules/userMenu.js'

Vue.use(Vuex);


export default new Vuex.Store({
    modules: {
        processors,
        menuOptions,
        systemValues,
        compareList,
        startIndexCPU,
        adminMenu,
    }
})